import React, { useEffect, useState } from 'react'
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { Baseurl } from '../../constants/env'
import { useSelector,useDispatch } from 'react-redux'
import axios from 'axios'
import { useSnackbar } from 'notistack';
import { setuserdata } from '../../features/auth'
import Tempfooter from '../Tempfooter'

const Profile = () => {
    const navigate = useNavigate()
    const [data,setData] = useState([])
    const [refresh,setRefresh] = useState(false)
    const [currentpassword,setCurrentpassword] = useState()
    const [newpassword,setNewpassword] = useState()
   
    const [addrr,setAddrr] = useState()
    const [phone,setPhone] = useState()
    const [editform,setEditform] = useState(false)
    const [myreviews, setMyreviews] = useState([]);

    const {userid, userdata, userlogedin} = useSelector(state => state.auth)
    const dispatch = useDispatch();
     const{enqueueSnackbar} = useSnackbar();
     const location = useLocation()
     const [currentPage, setCurrentPage] = useState(1);
     const [totalPages, setTotalPages] = useState(0);

     const [notification, setNotification] = useState([]);
     

    const orderNavigate = () => {
        navigate('/Profile/userorders')
    }
    const init = async () => {
      let res = await axios.get(`${Baseurl}/getuser?id=${userid}`)
      setData(res?.data)
      setAddrr(res?.data?.address?.[0].addrr)
      setPhone(res?.data?.address?.[0].phone)
      setNotification(res?.data?.userNotifications)
    }

   
const editAdress = async (e) => {
  e.preventDefault()
let params = {addrr,phone}

let res = await axios.post(`${Baseurl}/address?id=${userid}`,params)
if(res){
  await init()
}
}
    async function addWish(itemid){
      if(!userlogedin){
        return enqueueSnackbar('Login to add wishlist',{variant:'error'})
      }
      let data = {
       userid,
       productId:itemid
     }
    await axios.patch(`${Baseurl}/wishlist`,data ,{ withCredentials: true }).then((resp)=>{
    // dispatch(cartItem(resp.data.cartlength));          
    // setcartResp(resp);
     if(resp.status === 200){
       dispatch(setuserdata(true))
       dispatch(setuserdata(resp.data.userdata))
       localStorage.setItem('userdata',resp.data.cartlength)
       setRefresh(!refresh)
       return enqueueSnackbar('Product removed from wishlist',{variant:'success'})
     }
     if(resp.status === 201){
      dispatch(setuserdata(true))
      dispatch(setuserdata(resp.data.userdata))
      localStorage.setItem('userdata',resp.data.cartlength)
      return enqueueSnackbar('Product added to wishlist',{variant:'success'})
    }
     }).catch((err)=>{
     console.log(err);
     enqueueSnackbar(err,{variant:'error'})
    });
   }
   const handleSubmit = async (e) => {
    e.preventDefault()
    let params = {
      password:newpassword
    }
    await axios.patch(`${Baseurl}/getuser?id=${userid}&useredit=user`,params)
    setRefresh(!refresh)
  }

    useEffect(() => {
      init()
    },[refresh])
    const limit = 1;
const getmyReviews = async () => {
  const params = new URLSearchParams();
  params.append('page', currentPage );
  params.append('limit', 2 );
  let result = await axios(`${Baseurl}/reviews/user?id=${userid}&${params.toString()}`)
  setMyreviews(result?.data?.data)
  setTotalPages(result?.data?.totalPages);
 }

 const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
  window.scrollTo(0, 0);
};

const handleFirstPage = () => {
  setCurrentPage(1);
  window.scrollTo(0, 0);
};

const handleLastPage = () => {
  setCurrentPage(totalPages);
  window.scrollTo(0, 0);
};

// Generate page numbers for pagination
const getPageNumbers = () => {
  const pageNumbers = [];
  const maxPagesToShow = 5; // Show 5 page numbers at a time
  
  let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  let endPage = startPage + maxPagesToShow - 1;
  
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }
  
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }
  
  return pageNumbers;
};

useEffect(() => {
getmyReviews()
},[currentPage])

  return (
    <div >
      <main className='main'>
         <section className='section-inner-page'>
      
<div>

{/* My profile */}

<div class="container my-5">
<div class="row">

<div class="col-md-3 mb-4">
 <div class="account-card">

   <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist">
     <button className={`nav-link ${location.pathname === '/Profile' ? 'active' : '' }`} data-bs-toggle="pill" data-bs-target="#profile-tab" onClick={ () => navigate('/Profile') }  > Profile </button>
     <button className={`nav-link ${location.pathname === '/Profile/userorders' ? 'active' : '' }`} data-bs-toggle="pill" data-bs-target="#orders-tab" onClick={ () => navigate('/Profile/userorders') } > Orders</button>
     <button class="nav-link" data-bs-toggle="pill" data-bs-target="#wishlist-tab">Wishlist</button>
     <button class='nav-link'  data-bs-toggle="pill" data-bs-target="#user-noti">Notifications</button>
     <button class="nav-link" data-bs-toggle="pill" data-bs-target="#addresses-tab">Addresses</button>
     <button class="nav-link" data-bs-toggle="pill" data-bs-target="#review-tab">My Review</button>
     <button class="nav-link" data-bs-toggle="pill" data-bs-target="#password-tab">Change Password</button>
     <button class="nav-link  mt-3">Logout</button>
   </div>
 </div>
</div>


<div class="col-md-9">
 <div class="tab-content">

<Outlet />

 
   <div class="tab-pane fade" id="wishlist-tab">
     <div class="account-card">
       <h5 className='mb-3'>Your Wishlist</h5>
       <div class="row">



{ data?.wishlist?.length ? <div class="col-md-4">

{data?.wishlist?.map((item,index) => (
  <div class="product-box" key={index}>

<div class="project-image">

<img src={`${Baseurl}/view/imageupload/${item?.img}`} class="img-fluid"  />

</div>

<div class="product-details pb-0">
<h4>
 {item?.name}
</h4>
<div>              <span class="price">AED {item?.ourprice}</span> <span class="crossed-price"> AED {item?.mrpprice}</span>
</div>
<div class="ratings mb-2 mt-1"><img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid me-2" alt="image"/> 4.2
</div>


<div>
<button class="btn btn-primary btn-sm btn-danger mb-0" onClick={() => addWish(item?._id)}>Remove from wishlist</button>
</div>
</div>



</div>
))}





</div> : 
<div class="col-md-4">
Wishlist is Empty
 </div> }



</div>


     </div>
   </div>


   <div class="tab-pane fade" id="addresses-tab">
     <div class="account-card">

       {data?.address?.map((item,index) => (
        <div id="add-address"  key={index}>
         <h5>Saved Addresses</h5>
         <p><strong>Home:</strong> {item?.addrr}<br />Phone: {item?.phone}</p>
          {/* <button class="btn btn-danger btn-sm me-2" onclick="toggleForm('add-address')">Add New Address</button>  */}
         <button class="btn btn-secondary btn-sm" onClick={(e) => setEditform(!editform)}>Edit</button>
       </div>
       ))  }

        {data?.address?.length ? <></> :
        <div id="add-address" class="form-section d-block">
         <h5>Add Address</h5>
         <form>
           <div class="mb-2">
             <label class="form-label">Address</label>
             <input type="text" class="form-control" placeholder="Full Address" onChange={(e) => setAddrr(e.target.value)} />
           </div>
           <div class="mb-2">
             <label class="form-label">Phone</label>
             <input type="number" class="form-control" placeholder="Phone number"  onChange={(e) => setPhone(e.target.value)} />
           </div>
           <button class="btn btn-danger btn-sm me-2" onClick={(e) => editAdress(e)}>Save</button>
            {/* <button type="button" className=" ms-5 btn btn-secondary btn-sm">Cancel</button>  */}
         </form>
       </div>  }

     </div>
  
   {editform ? <div id="edit-address" class="form-section d-block">
         <h5>Edit Address</h5>
         <form>
           <div class="mb-2">
             <label class="form-label">Address</label>
             <input type="text" class="form-control" value={addrr} onChange={(e) => setAddrr(e.target.value)} />
           </div>
           <div class="mb-2">
             <label class="form-label">Phone</label>
             <input type="number" class="form-control" value={phone} onChange={(e) => setPhone(e.target.value)} />
           </div>
           <button class="btn btn-danger btn-sm me-2" onClick={(e) => editAdress(e)}>Update</button>
           <button type="button" class="btn btn-secondary btn-sm" onClick={() => setEditform(!editform)} >Cancel</button>
         </form>
       </div> : <></> }

       </div>


   <div class="tab-pane fade" id="review-tab">
     <div class="account-card">
       <div id="address-view">
         <h5>My Reviews</h5>
         
<div>
{myreviews?.map((item,index) => (
  <div class="review-box mb-2" key={index}>


             <div class="author-box d-flex w-100">

               <div class="author-image">

                 <img src={`${Baseurl}/view/imageupload/${item?.userId?.img}`}  alt='failed'/>

               </div>
               <div class="author-details">
                 <span class="author-name">
                   {item?.userId?.firstname} {item?.userId?.lastname}
                 </span>
                 <div class="author-designation">
                {new Date(item?.createdAt).toLocaleString()}
                 </div>
               </div>

             </div>
             <div className='mt-2 mb-3'>
<span class="ratings mb-2 mt-1">

              {[...Array(5)].map((_, i) => (
  <i
    key={i}
    className={`bi bi-star-fill ${
      i < Math.round(item.rating  || 0)
        ? 'text-warning' 
        : 'bi-star text-secondary' 
    } me-2`} 
    style={{ fontSize: '1rem' }} 
  ></i>
))}     
{`${Number.isInteger(item?.rating ) ? item?.rating  + '.0' : item?.rating }`}
</span>    
</div>
<h4 class="mt-2">{item?.productName}</h4>

               <h4 class="mt-2">{item?.headline || "Reviewed without heading"}</h4>


               <p>{item?.reviewText || "Reviewed without reviewText" }</p>


             </div>

))}
<div className="container mt-4">
          {totalPages > 0 && (
            <nav aria-label="Page navigation">
              <ul className="pagination justify-content-center">
                {/* First Page Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button 
                    className="page-link" 
                    onClick={handleFirstPage}
                    disabled={currentPage === 1}
                  >
                    First
                  </button>
                </li>
                
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button 
                    className="page-link" 
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &laquo;
                  </button>
                </li>
                
                {/* Page Numbers */}
                {getPageNumbers().map(number => (
                  <li 
                    key={number} 
                    className={`page-item ${currentPage === number ? 'active' : ''}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(number)}
                    >
                      {number}
                    </button>
                  </li>
                ))}
                
                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button 
                    className="page-link" 
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    &raquo;
                  </button>
                </li>
                
                {/* Last Page Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button 
                    className="page-link" 
                    onClick={handleLastPage}
                    disabled={currentPage === totalPages}
                  >
                    Last
                  </button>
                </li>
              </ul>
            </nav>
          )}
    
    </div>


           </div>

        
       </div>
       {/* <div id="add-address" class="form-section">
         <h5>Add Address</h5>
         <form>
           <div class="mb-2">
             <label class="form-label">Address</label>
             <input type="text" class="form-control" placeholder="Full Address" />
           </div>
           <div class="mb-2">
             <label class="form-label">Phone</label>
             <input type="text" class="form-control" placeholder="Phone number" />
           </div>
           <button class="btn btn-danger btn-sm me-2">Save</button>
           <button type="button" class="btn btn-secondary btn-sm" onclick="toggleForm('address-view')">Cancel</button>
         </form>
       </div>
       <div id="edit-address" class="form-section">
         <h5>Edit Address</h5>
         <form>
           <div class="mb-2">
             <label class="form-label">Address</label>
             <input type="text" class="form-control" value="123 Marina Blvd, Dubai" />
           </div>
           <div class="mb-2">
             <label class="form-label">Phone</label>
             <input type="text" class="form-control" value="+971 55 123 4567" />
           </div>
           <button class="btn btn-danger btn-sm me-2">Update</button>
           <button type="button" class="btn btn-secondary btn-sm" onclick="toggleForm('address-view')">Cancel</button>
         </form>
       </div> */}
     </div>
   </div>

   <div class="tab-pane fade" id="user-noti">
     <div class="tab-pane fade show active" id="orders-tab">
     <div class="account-card">
       <h5>Notifications</h5>
       <ul class="list-group ">
       {notification?.map((item,index) => (
        <div key={index}>
         <li class="list-group-item mt-3" >
           <strong>#{item?.message}</strong> - {}
           <br /><small>Alert Recived on {item?.date?.toLocaleString()}</small>

         </li> </div>
       ))}
 
         {/* <li class="list-group-item">
           <strong>#12344</strong> - AED 150
           <span class="float-end text-warning">Processing</span>
           <br /><small>Placed on Jan 22</small>       
         </li> */}
       </ul>
 


 
     
 
     </div>
   </div>
   </div>


   <div class="tab-pane fade" id="password-tab">
     <div class="account-card">
       <h5>Change Password</h5>
       <form>
         <div class="mb-2">
           <label>Current Password</label>
           <input type="password" class="form-control" onChange={(e) => setCurrentpassword(e.target.value)} />
         </div>
         <div class="mb-2">
           <label>New Password</label>
           <input type="password" class="form-control" onChange={(e) => setNewpassword(e.target.value)} />
         </div>
         <div class="mb-2">
           <label>Confirm Password</label>
           <input type="password" class="form-control" />
         </div>
         <button class="btn btn-danger" onClick={(e) => handleSubmit(e)}>Change Password</button>
       </form>
     </div>
   </div>

 </div>  
</div>
</div>
</div>
</div>
</section>
<Tempfooter />
</main>
    </div>
    
  )
}

export default Profile
